import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {
  IComplaintsDashboardView,
  IDashboardTypeBar,
} from '../../../../../core/interfaces/complaints-dashboard.interface';
import { ComplaintsDashboardStore } from '../../complaints-dashboard.store';

@Component({
  selector: 'app-dashboard-type-bars',
  templateUrl: './dashboard-type-bars.component.html',
  styleUrls: ['./dashboard-type-bars.component.scss'],
})
export class DashboardTypeBarsComponent {
  bars$: Observable<IDashboardTypeBar[]>;

  constructor(private store: ComplaintsDashboardStore) {
    this.bars$ = this.store.view$.map((view: IComplaintsDashboardView) =>
      view ? view.typeBars : [],
    );
  }

  trackByLabel(index: number, item: IDashboardTypeBar) {
    return item.label;
  }

  select(bar: IDashboardTypeBar) {
    this.store.toggle('type', bar.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-dashboard/components/dashboard-type-bars/dashboard-type-bars.component.ts